// composables/useCompanyFormData.ts
import QueryKey from '@/enums/QueryKey';
import { useQuery } from '@tanstack/vue-query';
import axios from 'axios';

export function useEmployeeData(companyId?: number) {
    const {
        data: employeesAndGroups,
        isFetching: isFetchingEmployeesAndGroups,
        isPlaceholderData: isPlaceholderDataEmployeesAndGroups,
    } = useQuery({
        queryKey: [QueryKey.KEEPERS_EMPLOYEES_GROUPS, companyId],
        queryFn: async () => {
            const { data } = await axios.post(route('v2.companies.keepers-employees.get'), {
                company_id: companyId,
            });
            return data;
        },
        placeholderData: [],
    });

    return {
        employeesAndGroups,
        isFetchingEmployeesAndGroups,
        isPlaceholderDataEmployeesAndGroups,
    };
}
